import React from "react";
import ReactDOMServer from "react-dom/server";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
let JSDOM: any;
if (typeof window === "undefined") {
  // Dynamically import jsdom only in Node.js to avoid bundling it in browser
  JSDOM = require("jsdom").JSDOM;
}

type Props = Readonly<{
  htmlContent: string | undefined;
  className?: string;
  loginComponent?: React.ReactElement;
}>;

export const RawUhfContainer = ({ htmlContent, className, loginComponent }: Props) => {
  if (!htmlContent) {
    return null;
  }

  if (!loginComponent) {
    return <div className={className} dangerouslySetInnerHTML={{ __html: htmlContent }} />;
  }

  let updatedHtmlContent: string;

  if (typeof window === "undefined") {
    // Server-side rendering using jsdom
    const dom = new JSDOM(htmlContent);
    const document = dom.window.document;

    const uhfContainer = document.querySelector(".c-uhfh-actions");
    if (uhfContainer) {
      const containerDiv = document.createElement("div");
      containerDiv.setAttribute("id", "meControl");
      containerDiv.setAttribute("class", "gdas-root");
      uhfContainer.appendChild(containerDiv);

      const reactComponentHtml = ReactDOMServer.renderToString(loginComponent);
      containerDiv.innerHTML = reactComponentHtml;
    }

    updatedHtmlContent = document.documentElement.outerHTML;
  } else {
    // Client-side rendering using DOMParser
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlContent, "text/html");

    const uhfContainer = doc.querySelector(".c-uhfh-actions");
    if (uhfContainer) {
      const containerDiv = document.createElement("div");
      containerDiv.setAttribute("id", "meControl");
      containerDiv.setAttribute("class", "gdas-root");
      uhfContainer.appendChild(containerDiv);

      const reactComponentHtml = ReactDOMServer.renderToString(loginComponent);
      containerDiv.innerHTML = reactComponentHtml;
    }

    updatedHtmlContent = doc.documentElement.outerHTML;
  }

  return <div className={className} dangerouslySetInnerHTML={{ __html: updatedHtmlContent }} />;
};
